import React from 'react';
import './Spinner.css';

/**
 * Modern loading spinner component
 * @param {Object} props - Component props
 * @param {string} [props.size='medium'] - Size of the spinner (small, medium, large)
 * @param {string} [props.message='Loading...'] - Optional loading message
 * @param {boolean} [props.fullPage=false] - Whether to center in the full page
 * @returns {JSX.Element} Spinner component
 */
const Spinner = ({ size = 'medium', message = 'Loading...', fullPage = false }) => {
  const containerClass = fullPage ? 'spinner-container full-page' : 'spinner-container';
  
  return (
    <div className={containerClass}>
      <div className={`modern-spinner ${size}`}>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
        <div className="spinner-circle"></div>
      </div>
      {message && <p className="spinner-message">{message}</p>}
    </div>
  );
};

export default Spinner;
